import React from "react";
import { useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";

const Navbar = () => {
  const { user } = useSelector((state) => state.auth);
  const navigate = useNavigate();
  const onLogoutClick = (e) => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    return navigate("/login");
  };

  const adminMenu = (
    <>
      <li className="nav-item dropdown ">
        <a
          className="nav-link dropdown-toggle"
          href="#"
          id="navbarDropdownMenuLink"
          role="button"
          data-bs-toggle="dropdown"
          aria-expanded="false"
        >
          <i class="bi bi-person-circle"></i> Admin
        </a>
        <ul className="dropdown-menu" aria-labelledby="navbarDropdownMenuLink">
          <li className="nav-item">
            <Link className="nav-link text-dark" to="/assestmet">
              Assessment
            </Link>
          </li>
          <li className="nav-item">
            <Link className="nav-link text-dark" to="/assestment-title">
              Assessment Title
            </Link>
          </li>
          <li className="nav-item">
            <Link
              className="nav-link text-dark"
              to="/assesment-title-indicator"
            >
              Assessment Title indicator
            </Link>
          </li>

          <li className="nav-item">
            <Link className="nav-link text-dark" to="/assesment-opinion">
              Assessment Opinion
            </Link>
          </li>

          <li className="nav-item">
            <Link className="nav-link text-dark" to="/competency">
              Competency
            </Link>
          </li>
          <li className="nav-item">
            <Link className="nav-link text-dark" to="/competencyOpinion">
              Competency Opinion
            </Link>
          </li>
          <li className="nav-item">
            <Link
              className="nav-link text-dark"
              to="/competency-Title-Indicator"
            >
              Competency Title Indicator
            </Link>
          </li>
          <li className="nav-item">
            <Link className="nav-link text-dark" to="/RoleCompetencyRca">
              Role Competency RCA
            </Link>
          </li>
          <li className="nav-item">
            <Link className="nav-link text-dark" to="/quarter">
              Quarter
            </Link>
          </li>
          <li className="nav-item">
            <Link className="nav-link text-dark" to="/rolename">
              Role Type
            </Link>
          </li>
          <li className="nav-item">
            <Link className="nav-link text-dark" to="/userRoleNames">
              User Role
            </Link>
          </li>
          <li className="nav-item">
            <Link className="nav-link text-dark" to="/skillMatrix">
              Skill Matrix
            </Link>
          </li>
          <li className="nav-item">
            <Link className="nav-link text-dark" to="/matrixOpinion">
              Matrix Opinion
            </Link>
          </li>
        </ul>
      </li>

      <li className="nav-item">
        <Link className="nav-link text-dark" to="/">
          Dashboard
        </Link>
      </li>
    </>
  );

  return (
    <header>
      <nav className="navbar navbar-expand-sm navbar-toggleable-sm navbar-light bg-white border-bottom box-shadow mb-3">
        <div className="container">
          <Link to="/" className="navbar-brand">
            PMS
          </Link>
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target=".navbar-collapse"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon" />
          </button>
          <div className="navbar-collapse collapse d-sm-inline-flex justify-content-between">
            <ul className="navbar-nav flex-grow-1">
              <li className="nav-item">
                <Link className="nav-link text-dark" to="/">
                  <i class="bi bi-house-fill"></i> Home
                </Link>
              </li>

              {user.userRoles === "User" ? (
                <></>
              ) : (
                <li className="nav-item dropdown">
                  <a
                    className="nav-link text-dark dropdown-toggle"
                    href="#"
                    role="button"
                    data-bs-toggle="dropdown"
                  >
                    <i class="bi bi-people-fill"></i> Management
                  </a>
                  <ul className="dropdown-menu">
                    <li className="nav-item">
                      <Link className="nav-link text-dark" to="/ManagementDashboard">Dashboard</Link>
                    </li>
                    <li className="nav-item">
                      <Link className="nav-link text-dark" to="/employee-idp-admin">Employee IDP</Link>
                    </li>
                    <li className="nav-item">
                      <Link className="nav-link text-dark" to="/management-employee-matrix">Employee Matrix</Link>
                    </li>
                    <li className="nav-item">
                      <Link className="nav-link text-dark" to="/MarksSummary">User Marks</Link>
                    </li>
                    <li className="nav-item">
                      <Link className="nav-link text-dark" to="/supervisor-update">Supervisor Update</Link>
                    </li>
                    <li className="nav-item">
                      <Link className="nav-link text-dark" to="/employee-insert">Insert/Active/Inactive Employee</Link>
                    </li>
                    <li className="nav-item">
                      <Link className="nav-link text-dark" to="/matrix-library">User Matrix</Link>
                    </li>
                    <li className="nav-item">
                      <Link className="nav-link text-dark" to="/matrix-library-create">Matrix Title</Link>
                    </li>
                    <li className="nav-item">
                      <Link className="nav-link text-dark" to="/TaskListDashboard">Planning Dashboard</Link>
                    </li>
                    <li className="nav-item">
                      <Link className="nav-link text-dark" to="/PMSCycleReport">PMS Cycle Report</Link>
                    </li>
                    <li className="nav-item">
                      <Link className="nav-link text-dark" to="/EvaluationReportSummary">Evaluation Report Summary</Link>
                    </li>
                    <li className="nav-item">
                      <Link className="nav-link text-dark" to="/HeadSetup">Head Setup</Link>
                    </li>
                    <li className="nav-item">
                      <Link className="nav-link text-dark" to="/EmployeePromotionReport">Employee Promotion Report</Link>
                    </li>
                  </ul>
                </li>
              )}

{user.isPlanningLocked === true ? (
                <></>
              ) : (

<li className="nav-item dropdown">
                <a
                  className="nav-link text-dark dropdown-toggle"
                  href="#"
                  role="button"
                  data-bs-toggle="dropdown"
                >
                  {" "}
                  <i class="bi bi-clipboard2-check-fill"></i> Planning
                </a>
                <ul className="dropdown-menu">
                  <li className="nav-item">
                    <Link className="nav-link text-dark" to="/EmployeeTaskList">
                      <i class="bi bi-phone"></i> Task List
                    </Link>
                  </li>
                  {user.isSupervised === 0 ? (
                    <></>
                  ) : (
                    <li className="nav-item">
                      <Link className="nav-link text-dark" to="/SupervisorRemarksForTaskList">
                        <i class="bi bi-phone"></i> Supervisor Remarks
                      </Link>
                    </li>
                    
                  )}
                     {user.isSupervised === 0 ? (
                    <></>
                  ) : (
                    <li className="nav-item">
                      <Link className="nav-link text-dark" to="/EmployeeWiseActionPlan">
                        <i class="bi bi-phone"></i> Action Plan
                      </Link>
                    </li>
                    
                  )}
                   {user.isSupervised === 0 ? (
                    <></>
                  ) : (
                    <li className="nav-item">
                      <Link className="nav-link text-dark" to="/TaskListReport">
                        <i class="bi bi-phone"></i> Task List Report
                      </Link>
                    </li>
                    
                  )}
                </ul>
              </li>
 )}

              <li className="nav-item dropdown">
                <a
                  className="nav-link text-dark dropdown-toggle"
                  href="#"
                  role="button"
                  data-bs-toggle="dropdown"
                >
                  {" "}
                  <i class="bi bi-clipboard2-check-fill"></i> Core Values
                </a>
                <ul className="dropdown-menu">
                  <li className="nav-item">
                    <Link className="nav-link text-dark" to="/self-assessment">
                      Self Assessment
                    </Link>
                  </li>
                  {user.isSupervised === 0 ? (
                    <></>
                  ) : (
                    <li className="nav-item">
                      <Link
                        className="nav-link text-dark"
                        to="/SupervisorAssessment"
                      >
                        Supervisor Assessment
                      </Link>
                    </li>
                  )}
                </ul>
              </li>

              <li className="nav-item dropdown">
                <a
                  className="nav-link text-dark dropdown-toggle"
                  href="#"
                  role="button"
                  data-bs-toggle="dropdown"
                >
                  <i class="bi bi-clipboard2-check-fill"></i> Core Competency
                </a>
                <ul className="dropdown-menu">
                  <li className="nav-item">
                    <Link
                      className="nav-link text-dark"
                      to="/selfCompetencyAssessment"
                    >
                      Self Assessment
                    </Link>
                  </li>
                  {user.isSupervised === 0 ? (
                    <></>
                  ) : (
                    <li className="nav-item">
                      <Link
                        className="nav-link text-dark"
                        to="/SupervisorCompetencyOpinion"
                      >
                        Supervisor Assessment
                      </Link>
                    </li>
                  )}
                </ul>
              </li>

              <li className="nav-item dropdown">
                <a
                  className="nav-link text-dark dropdown-toggle"
                  href="#"
                  role="button"
                  data-bs-toggle="dropdown"
                >
                  <i class="bi bi-table"></i> Skill Will Matrix
                </a>
                <ul className="dropdown-menu">
                  <li className="nav-item">
                    {user.isSupervised === 0 ? (
                      <></>
                    ) : (
                      <Link className="nav-link text-dark" to="/EmployeeMatrix">
                        Skill Will Matrix
                      </Link>
                    )}
                    <Link className="nav-link text-dark" to="/EmployeeWillMatrix">
                      Skill Will Matrix(Quadrant)
                    </Link>
                    <Link className="nav-link text-dark" to="/PromotionRecommendation">
                      Promotion Recommendation(Supervisor)
                    </Link>
                    {user.isDeptHead === 1 ? (
                      <Link className="nav-link text-dark" to="/PromotionRecommendationForHOD">
                      Promotion Recommendation(HOD)
                    </Link>                      
                    ) : (
                      <></>
                    )}
                    {user.isDivisionHead === 1 ? (
                      <Link className="nav-link text-dark" to="/PromotionRecommendationForDivisionHead">
                      Promotion Recommendation(Division Head)
                    </Link>                      
                    ) : (
                      <></>
                    )}
                    {user.isHrHead === 1 ? (
                      <Link className="nav-link text-dark" to="/PromotionRecommendationForHR">
                      Promotion Review/Comments(HR)
                    </Link>                      
                    ) : (
                      <></>
                    )}
                    {/* <Link className="nav-link text-dark" to="/user-email-update">
                      Update User Email
                    </Link> */}
                  </li>
                </ul>
              </li>

              <li className="nav-item dropdown">
                <a
                  className="nav-link text-dark dropdown-toggle"
                  href="#"
                  role="button"
                  data-bs-toggle="dropdown"
                >
                  <i class="bi bi-sticky-fill"></i> IDP
                </a>
                <ul className="dropdown-menu">
                  {user.isSupervised === 0 && user.userRoles === "User" ? (
                    <></>
                  ) : (
                    <li className="nav-item">
                      <Link className="nav-link text-dark" to="/EmployeeIDP">
                        Performance Evaluation Report
                      </Link>
                    </li>
                  )}

                  <li className="nav-item">
                    <Link className="nav-link text-dark" to="/MyIdp">
                      My IDP
                    </Link>
                  </li>
                  {/* <li className="nav-item">
                    <Link className="nav-link text-dark" to="/MyIdp">
                      IDP Report
                    </Link>
                  </li> */}
                </ul>
              </li>



              <li className="nav-item dropdown">
                <a
                  className="nav-link text-dark dropdown-toggle"
                  href="#"
                  role="button"
                  data-bs-toggle="dropdown"
                >
                  <i class="bi bi-table"></i> Report
                </a>
                <ul className="dropdown-menu">
                  <li className="nav-item">
                    {user.isSupervised === 0 ? (
                      <></>
                    ) : (
                      <Link className="nav-link text-dark" to="/SupervisorUserMarks">
                        User Marks(Supervisor)
                      </Link>
                    )}
                    {user.isDeptHead === 1 ? (
                      <Link className="nav-link text-dark" to="/HodUserMarks">
                      User Marks(HOD)
                    </Link>                      
                    ) : (
                      <></>
                    )}
                    {user.isDivisionHead === 1 ? (
                      <Link className="nav-link text-dark" to="/DivisionHeadUserMarks">
                      User Marks(Division Head)
                    </Link>                      
                    ) : (
                      <></>
                    )}
                    {user.isHrHead === 1 ? (
                      <Link className="nav-link text-dark" to="/HRUserMarks">
                      User Marks(HR)
                    </Link>                      
                    ) : (
                      <></>
                    )}
                    {/* <Link className="nav-link text-dark" to="/user-email-update">
                      Update User Email
                    </Link> */}
                  </li>
                </ul>
              </li>




              <li className="nav-item">
                <Link className="nav-link text-dark" to="/contact-person">
                  <i class="bi bi-phone"></i> Contact
                </Link>
              </li>
                          

              {user.isAdmin ? adminMenu : ""}
            </ul>
            {
              <div className="pull-right">
                {/* <a>{user.employeeName} [<b className="text-danger">{user.roleName}</b>]</a>
                            <span className='m-1 text-primary' style={{cursor: 'pointer'}}
                                  onClick={onLogoutClick}>Logout</span> */}

                <ul>
                  <li className="nav-item dropdown" style={{ listStyle: "none" }}>
                    <a
                      className="nav-link dropdown-toggle"
                      href="#"
                      id="navbarDropdownMenuLink"
                      role="button"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      <i class="bi bi-person-fill"></i> Hi, Logout
                    </a>
                    <ul
                      className="dropdown-menu p-2"
                      style={{ fontSize: ".9rem" }}
                      aria-labelledby="navbarDropdownMenuLink"
                    >
                      <li>
                        <a className="nav-link text-dark">
                          <i className="bi bi-app-indicator" />{" "}
                          {user.employeeName}
                        </a>
                      </li>
                      <li>
                        <hr className="dropdown-divider" />{" "}
                      </li>
                      <li>
                        <a className="nav-link text-dark">
                          <b className="text-danger">
                            <i className="bi bi-bookmark-check" /> {user.roleName}
                          </b>
                        </a>
                      </li>
                      <li>
                        <hr className="dropdown-divider" />{" "}
                      </li>
                      <li className="nav-item">
                        <Link className="nav-link text-dark" to="/PasswordChange">
                          <i class="bi bi-person-lines-fill"></i> Update Information
                        </Link>
                      </li>
                      <li>
                        <hr className="dropdown-divider" />{" "}
                      </li>
                      <li>
                        <span
                          className="m-1 text-primary"
                          style={{ cursor: "pointer" }}
                          onClick={onLogoutClick}
                        >
                          <i className="bi bi-lock-fill" /> Logout
                        </span>
                      </li>
                    </ul>
                  </li>
                </ul>
              </div>
            }
          </div>
        </div>
      </nav>
    </header>
  );
};

export default Navbar;
